import { useFetch } from "../../hooks/useFetch";
import LoadSimple from "../LoadSimple";
import Modal from 'react-modal';
import ModalDeleteUSer from "./ModalDeleteUser";
import { useState, useEffect } from "react";
import { lang } from "../generales/traduction";
import { capitalizeFirstLetter } from "../../utils/utils";
const deleteUserModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width:'30%',
    height:'20%',
    padding:'20px'
  },
};
const PortafolioDevicesList = ({
  pageActual,
  limitList,startLimit,
  dataList,
  devices,
  handleChangEdit,
  setData,
  setRegisterIsValid,
  setLoading,
  setError,
  server,
  dataUsers,
  setDataUsers,
  searchResults,
  setSearchResults,
  searchTerm,
  cisSelected,
  setServiceSelected,
  ServiceSelected,
  dataService,
  setDataService,
  sla,
  setSla,
  dataObject,
  setDataObject,
  tecSelected,
  setTecSelected,
       slaService,
         setSlaService,
         slaTech,
         setSlaTech,
  dataCisConf,handleShowPopup,
languaje,mode
}) => {
  
  const [deleteUserModalOpen, setDeleteUserModalOpen] =useState(false);
  const [closeUserModalOpen, setCloseUserModalOpen] =useState(false);
  const [userSelected,setUserSelected]=useState({})
  useEffect(() => {
    if(dataCisConf.loading==false){
      search_services();
    }
    
  }, [dataCisConf.loading]);
  
  function openDeleteUserModal() {
    setDeleteUserModalOpen(true);
  }

  function closDeleteUserModal() {
    setDeleteUserModalOpen(false);
  }
  const handledeleteUserClick = (data) => {
        
    openDeleteUserModal()
    setUserSelected(data)
    // Realiza las acciones deseadas al hacer clic en el marcador
  };
  const search_services = () => {
    // setLoadingCis(true)
    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url +
            "/api/v1/cassia/services/techs/devices/"+tecSelected.cassia_tech_id,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
     
        if (response.ok) {
          const data1 = await response.json();
          // setLoadingCis(false)
          
          setSlaService(data1.data.sla_service)
          setSlaTech(data1.data.sla_tech)
          setDataUsers(data1);
          
          setDataObject(data1)
          // setDataService(data1)
          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
        
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };
  const ServiceSelectRow = (elemento) => {
    
    setTecSelected(elemento);
    setSla(elemento.sla)
  };

  return (
    <>
      <div className="cont-row-user-list">
        {dataCisConf.loading || dataUsers.loading  ? (
          <div className="cont-load-user-list">
            <LoadSimple></LoadSimple>
          </div>
        ) : (
          dataList
            .slice(startLimit, parseInt(pageActual) * parseInt(limitList))
            .map((elemento, indice) => (
              <div
                className={"row-table-portafolio"+mode}
                key={indice}
                // onClick={() => ServiceSelectRow(elemento)}
              >
                <div className="field-body-table-portafolio field-small">
                  {elemento.cassia_tech_device_id}
                </div>
                <div className="field-body-table-portafolio field-medium">
                  {elemento.hostid}
                </div>
                <div className="field-body-table-portafolio field-larger">
                  {elemento.ip}
                </div>
                <div className="field-body-table-portafolio field-larger" style={{width:'40%'}}>
                  {elemento.host}
                </div>
                <div className="field-body-table-portafolio field-larger" style={{width:'25%'}}>
                  {elemento.location}
                </div>
                <div className="field-body-table-portafolio field-medium">
                  {elemento.formatted_sla}
                </div>
                <div className="field-body-table-portafolio field-medium">
                {(elemento.cassia_criticality_id==null)?'N/A':elemento.cassia_criticality_id}
                </div>
                <div className="field-body-table-portafolio field-medium">
                <p style={{color:(elemento.status==1)?((mode=='')?"green":'lime'):"red"}}>
                      {
                        (elemento.status==1)?lang[languaje]['activo'].toUpperCase():lang[languaje]['inactivo'].toUpperCase()
                      }
                    </p>
                </div>
                
                <div className="field-body-table-mantenimiento field-larger">
                  {/* <div style={{width:'33%'}}>
                  <img
                    src={
                      "/iconos/editar.png"
                    } 
                    onClick={(e) => {
                      e.stopPropagation();
                      handleChangEdit(elemento);
                    }}
                   
                    name="Editar" title="Editar" className="btnAction delteException" style={{width:'30%'}}
                  />
                  </div> */}
                  
                  <div style={{width:'33%'}}>
                  <img
                    src={
                      "/iconos/delete.png"
                    } 
                    onClick={(e) => {
                      e.stopPropagation();
                      handledeleteUserClick(elemento);
                    }}
                    name="Eliminar"  title='Eliminar' className="btnAction delteException" style={{width:'30%'}}
                  />
                  </div>
                  
                </div>
              </div>
              
            ))
          
        )}
        {dataUsers.loading==undefined && dataList.length == 0 ? (
          <div className="no-results">{lang[languaje]['sinResultados']}.</div>
        ) : (
          ""
        )}
      </div>
      <Modal
        isOpen={deleteUserModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closDeleteUserModal}
        style={deleteUserModalStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
        >
          <ModalDeleteUSer handleShowPopup={handleShowPopup} languaje={languaje} nivel={3}  search_data={search_services} url='services/techs/devices/' data_id={userSelected.cassia_tech_device_id} data_text={userSelected.host}  title={'dispositivo'} server={server} setData={setData} setLoading={setLoading} setError={setError} user={userSelected} closDeleteUserModal={closDeleteUserModal}></ModalDeleteUSer>
    </Modal>
    </>
  );
};

export default PortafolioDevicesList;
